export default __webpack_public_path__ + "static/media/bannerImg2.8bdec6c1.png";